import React from 'react';
import { PHONE_W, PHONE_H, STATUS_H, RING_135, MONO } from './landingTokens';

/**
 * The phone mockup: a 390×844 screen behind a 3px ring-gradient bezel (radius 62 outside,
 * 48 inside) with the status bar drawn on top. `bg` is the screen's ground (#F5F5F5 for the
 * app, #000 for the dark screens). The parent scales it with CSS zoom (`data-pz`).
 */
export function StatusBar({ dark = true }) {
  return (
    <div aria-hidden style={{ position: 'relative', zIndex: 5, height: STATUS_H, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 30px 0 36px', background: dark ? '#000' : 'transparent', color: '#fff', fontFamily: '-apple-system, system-ui, sans-serif', fontSize: 15, fontWeight: 600, flexShrink: 0 }}>
      <span>9:41</span>
      <span style={{ position: 'absolute', top: 11, left: '50%', width: 120, height: 34, marginLeft: -60, borderRadius: 999, background: '#000', boxShadow: dark ? 'none' : '0 0 0 1px #111' }} />
      <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <svg width="18" height="12" viewBox="0 0 18 12" fill="#fff"><rect x="0" y="8" width="3" height="4" rx="1" /><rect x="5" y="5" width="3" height="7" rx="1" /><rect x="10" y="2.5" width="3" height="9.5" rx="1" /><rect x="15" y="0" width="3" height="12" rx="1" /></svg>
        <span style={{ display: 'flex', alignItems: 'center', width: 25, height: 12, padding: 1, border: '1px solid rgba(255,255,255,.5)', borderRadius: 4, boxSizing: 'border-box' }}><span style={{ width: '100%', height: '100%', borderRadius: 2, background: '#fff' }} /></span>
      </span>
    </div>
  );
}

export default function PhoneFrame({ children, bg = '#F5F5F5', fixedHeight = true, style, ...rest }) {
  return (
    <div style={{ position: 'relative', padding: 12, border: '3px solid transparent', borderRadius: 62, background: `linear-gradient(#000,#000) padding-box, ${RING_135} border-box`, ...style }} {...rest}>
      <div style={{ position: 'relative', width: PHONE_W, height: fixedHeight ? PHONE_H : undefined, borderRadius: 48, overflow: 'hidden', background: bg, fontFamily: MONO, color: '#000', display: 'flex', flexDirection: 'column' }}>
        <StatusBar dark />
        {children}
      </div>
    </div>
  );
}
